import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import get from 'lodash.get';

import { makeSelectHarvestEvent } from 'services/harvestEvents/selectors';

// Constants
import { FORM_NAME } from './constants';

import { selectGroups } from '../../../../../../services/groups/selectors';
import { selectEntityDefaultJobs } from '../../../../../../services/userEntityAssignments/selectors';

const selectDefaultValues = (state, props) => props.defaultValues;

const selectInitialValues = createSelector(
    [
        makeSelectHarvestEvent(),
        selectGroups,
        selectDefaultValues,
        selectEntityDefaultJobs
    ],
    (
        harvestEventState,
        groupsState,
        defaultValuesState,
        entityDefaultJobsState
    ) => {
        if (!harvestEventState) {
            return {
                ...defaultValuesState,
                jobs: entityDefaultJobsState
            };
        }

        const { groupIds = [], jobs } = harvestEventState;

        return {
            ...harvestEventState,
            // Remove groupId if group doesn't exist
            groupIds: groupIds
                ? groupIds.filter(groupId => get(groupsState, groupId))
                : null,
            jobs: jobs.map(value => ({
                ...value,
                assignedUsers: value.assignedUsers.map(
                    assignedUser => assignedUser.email
                )
            }))
        };
    }
);

const formSelector = formValueSelector(FORM_NAME);

const makeSelectFormValue = field =>
    createSelector(
        state => formSelector(state, field),
        value => value
    );

const selectScheduledQuantity = createSelector(
    makeSelectFormValue('quantitySchedules'),
    (quantitySchedulesState = []) =>
        quantitySchedulesState.reduce(
            (sum, { value = 0 }) => sum + Number(value),
            0
        )
);

export { selectInitialValues, makeSelectFormValue, selectScheduledQuantity };
